import {CommonModule} from '@angular/common';
import {ModuleWithProviders, NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';

import {TranslateModule} from '@ngx-translate/core';

import {Breadcrumbs} from './breadcrumbs/breadcrumbs.component';
import {OrgEditModalComponent} from './org-edit-modal.component';
import {TreeDiagramComponent} from './tree-diagram.component';

import {TooltipModule} from 'ngx-bootstrap/tooltip';
import {OrgFileDetailComponent} from '../../+organizations/manage/org-file-detail.component';
import {OrgFileTopCardComponent} from '../../+organizations/manage/org-file-top-card.component';
import {OrgTreeService} from '../../+organizations/org-tree.service';
import {ChangeTrackingModule} from '../change-tracking/change-tracking.module';
import {EmployeesSharedModule} from '../employees/employees-shared.module';
import {FormGeneratorModule} from '../form-generator/form-generator.module';
import {LogEventModule} from '../log-event/log-event.module';
import {ModalModule} from '../modal/modal.module';
import {PipesModule} from '../pipes/pipes.module';
import {UiModule} from '../ui/ui.module';
import {UserModule} from '../user/user.module';

@NgModule({
  imports: [
    CommonModule,
    PipesModule,
    TooltipModule.forRoot(),
    TranslateModule,
    UiModule,
    ModalModule,
    FormsModule,
    UserModule,
    FormGeneratorModule,
    ReactiveFormsModule,
    ChangeTrackingModule,
    LogEventModule,
    EmployeesSharedModule
  ],
  declarations: [
    TreeDiagramComponent,
    Breadcrumbs,
    OrgEditModalComponent,
    OrgFileTopCardComponent,
    OrgFileDetailComponent
  ],
  exports: [
    OrgEditModalComponent,
    TreeDiagramComponent,
    Breadcrumbs,
    OrgFileTopCardComponent,
    OrgFileDetailComponent
  ],
  providers: []
})
export class TreeDiagramModule {
  public static forRoot(): ModuleWithProviders<TreeDiagramModule> {
    return {
      ngModule: TreeDiagramModule,
      providers: [
        OrgTreeService
      ]
    };
  }
}
